'use client'

import { useEffect } from 'react'
import { useSessionStorage } from 'usehooks-ts'

import { useExperimentsContext } from '../components/ExperimentsContext'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_DYNAMIC_RANKING } from '../model/EXPERIMENT_NAME'

import { ALGOLIA_DYNAMIC_RANKING_STATUS_KEY } from './useCheckAndStoreAlgoliaDynamicRankingStatus'

/**
 * Hook to activate the dynamic re-ranking search experiment
 * when the user starts typing in the search box.
 */
export const useActivateAlgoliaDynamicRankingExperimentInPdp = (): void => {
  const { addExperimentKeysForActivation } = useExperimentsContext()
  const [algoliaDynamicRankingStatus] = useSessionStorage<boolean>(
    ALGOLIA_DYNAMIC_RANKING_STATUS_KEY,
    false,
    {
      initializeWithValue: false,
    },
  )
  const dynamicRankingExperiment = useGetExperiment(
    EXPERIMENT_NAME_DYNAMIC_RANKING,
  )
  useEffect(() => {
    if (dynamicRankingExperiment.isEnabled && algoliaDynamicRankingStatus) {
      addExperimentKeysForActivation(EXPERIMENT_NAME_DYNAMIC_RANKING)
    }
  }, [
    addExperimentKeysForActivation,
    dynamicRankingExperiment.isEnabled,
    algoliaDynamicRankingStatus,
  ])
}
